import React from "react";
import { observer, useLocalStore } from "mobx-react";
import SAPSalesOrgPicker from "../SAPpickers/SAPSalesOrgPicker";
import ShortTextEditor from "../input/ShortTextEditor";
import SAPIncotermPicker from "../SAPpickers/SAPIncotermPicker";
import SAPpaymenttermPicker from "../SAPpickers/SAPpaymenttermPicker";
import SAPpackagingPicker from "../SAPpickers/SAPpackagingPicker";
import SAPCurrencyPicker from "../SAPpickers/SAPCurrencyPicker";
import SAPMaterialPicker from "../SAPpickers/SAPMaterialPicker";
// import {
//   Add,
//   ArrowDownward,
//   ArrowUpward,
//   CloudUpload,
//   ImportExport,
//   MergeType,
// } from "@material-ui/icons";
import NumberEditor from "../input/NumberEditor";
import { EOCSwitch } from "../input/EOCSwitch";
import { EOCSelect } from "../input/EOCSelect";
import SAPShippingPicker from "../SAPpickers/SAPShippingPicker";
import SAPEmployeePicker from "../SAPpickers/SAPEmployeePicker";
import Loader from "../Loader";
import useDocumentTitle from "../layout/title";
import MyDatePicker from "../input/MyDatePicker";
import { makeStyles } from "@mui/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextareaAutosize,
} from "@mui/material";
import {
  Add,
  ArrowDownward,
  ArrowUpward,
  CloudUpload,
  Delete,
  ExpandMore,
  ImportExport,
  MergeType,
} from "@mui/icons-material";
import theme from "../layout/theme";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";
import SAPInco2Picker from "../SAPpickers/SAPInco2Picker";

const useStyles = makeStyles({
  row: {
    fontWeight: "bold",
    background: theme.palette.primary.light,
    // "& td": { fontSize: "medium", fontWeight: "bold" },
  },
  row2: {
    "& th": { fontWeight: "bolder", color: theme.palette.secondary.light },
  },
  diff: {
    "& label": { color: "red", fontSize: "larger" },
    "& input": { color: "red", fontWeight: "bold" },
    "& p": { color: "red", fontWeight: "bold" },
  },
  notCompl: { border: "2px solid red" },
});

export default observer(({ trySave, store, quote, type }) => {
  var sys = window.localStorage.getItem("QUOTEsys");

  useDocumentTitle("Quotes " + sys);
  const classes = useStyles();
  console.log(quote);
  console.log(store);
  return (
    <Box m={1} p={1} style={{ background: "white" }}>
      <Loader loading={store.loading} />
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <h3> Organizational Info</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12}>
              <MyDatePicker
                title="Creation date"
                value={Date.now()}
                viewonly
                format="DD-MM-YYYY hh:mm"
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              className={
                trySave && quote.Salesrep === null ? classes.notCompl : ""
              }
            >
              <SAPEmployeePicker
                title="Sales Rep"
                value={quote.Salesrep}
                updatefunc={(val) => {
                  quote.change(val, "Salesrep");
                }}
                // so={quote.Salesorg}
              />
            </Grid>
            <Grid item xs={12} md={6} paddingLeft={1.5}>
              <label>Sales Organisation</label>
              <p></p>
              {(false && (
                <SAPSalesOrgPicker
                  title="Sales Organisation"
                  value={{ label: quote.Salesorg, value: quote.Salesorg }}
                  updatefunc={(val) => {
                    console.log(val);
                    quote.change(val, "Salesorg");
                  }}
                />
              )) ||
                quote.Salesorg}
            </Grid>
            <Grid item xs={12}>
              <Table size={"small"}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <h3>Sold to</h3>
                    </TableCell>
                    <TableCell>
                      <h3>Ship to</h3>
                    </TableCell>
                    <TableCell>
                      <h3>Z2/Y2 Contact (Receiver of Quotation)</h3>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>
                      <p>
                        {`${store.SSPItem.SoldTo} ${store.SSPItem.SoldToName}`}
                      </p>
                      <p>
                        {`${store.SSPItem.SoldToCountry} ${store.SSPItem.SoldToPostcode} ${store.SSPItem.SoldToCity}`}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p>{`${store.SSPItem.ShipTo} ${store.SSPItem.ShipToName}`}</p>
                      <p>
                        {`${store.SSPItem.ShipToCountry} ${store.SSPItem.ShipToPostcode} ${store.SSPItem.ShipToLocation}`}
                      </p>
                    </TableCell>
                    <TableCell>
                      <p>{`${store.SSPItem.Z2name}`}</p>
                      {/* <p>{`Fax: ${store.SSPItem.Z2fax}`}</p> */}
                      <p>{`Mail: ${store.SSPItem.Z2mail}`}</p>
                      <p>{`${store.SSPItem.Y2name}`}</p>
                      {/* <p>{`Fax: ${store.SSPItem.Y2fax}`}</p> */}
                      <p>{`Mail: ${store.SSPItem.Y2mail}`}</p>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <h3>Quotation Header</h3>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container>
            <Grid item xs={12}>
              <QuoteDetails
                trySave={trySave}
                ssp={store.SSPItem}
                quote={quote}
                type={type}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      <Accordion defaultExpanded>
        <AccordionSummary
          className={
            trySave && quote.Items.length === 0 ? classes.notCompl : ""
          }
          expandIcon={<ExpandMore />}
        >
          <h3>Quotation Items</h3>
        </AccordionSummary>
        <AccordionDetails>
          <QuoteItems trySave={trySave} quote={quote} type={type} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
});

const QuoteDetails = observer(({ trySave, ssp, quote, type }) => {
  const classes = useStyles();

  const quoteTypes = [
    { value: "ZQT", label: "(ZQT) Standard" },
    { value: "ZQTS", label: "(ZQTS) Sample (Free)" },
    { value: "ZQTT", label: "(ZQTT) Trial (Reduced Cost)" },
    { value: "ZQTL", label: "(ZQTL) Limited (for one time delivery)" },
  ];
  return (
    <Grid container spacing={1.5}>
      <Grid
        item
        xs={12}
        md={3}
        className={trySave && quote.Doctype === "" ? classes.notCompl : ""}
      >
        <label>Quotation type</label>
        {type === "extend" ? (
          <p>
            {quoteTypes.filter((el) => el.value === quote.Doctype).pop().label}
          </p>
        ) : (
          <EOCSelect
            optionItems={quoteTypes}
            value={quoteTypes.filter((el) => el.value === quote.Doctype).pop()}
            updateF={(val) => {
              quote.change(val.value, "Doctype");
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={trySave && quote.Reference === "" ? classes.notCompl : ""}
      >
        <ShortTextEditor
          title="Po Reference"
          value={quote.Reference}
          updatefunc={(val) => {
            quote.change(val.substr(0, 35), "Reference");
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <label>Mail Quotation to customer</label>
        <EOCSwitch
          checked={quote.toCustomer}
          onChange={(e) => {
            quote.change(e.target.checked, "toCustomer");
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={quote.Currency !== ssp.DefaultCurrency ? classes.diff : ""}
      >
        {type === "extend" ? (
          <>
            <label>Currency ({ssp.DefaultCurrency})</label>
            <p>{quote.Currency}</p>
          </>
        ) : (
          <SAPCurrencyPicker
            title={"Currency (" + ssp.DefaultCurrency + ")"}
            value={{ label: quote.Currency, value: quote.Currency }}
            updatefunc={({ value }) => {
              quote.change(value, "Currency");
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={trySave && quote.Validfrom === null ? classes.notCompl : ""}
      >
        <MyDatePicker
          title="Valid from"
          value={quote.Validfrom}
          viewonly={type === "extend" || type === "replace"}
          updatefunc={(val) => {
            quote.change(val, "Validfrom");
          }}
          format="DD-MM-YYYY"
          start={new Date().setMonth(new Date().getMonth() - 1)}
          end={quote.ValidTo}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={trySave && quote.ValidTo === null ? classes.notCompl : ""}
      >
        <MyDatePicker
          title="Valid to"
          value={quote.ValidTo}
          updatefunc={(val) => {
            quote.change(val, "ValidTo");
          }}
          format="DD-MM-YYYY"
          start={quote.Validfrom}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={
          quote.Paymentterm !== ssp.DefaultPaymentterm ? classes.diff : ""
        }
      >
        {((type === "extend" || type === "replace") && (
          <>
            <label>Payment conditions({ssp.DefaultPaymentterm})</label>
            <p>{quote.Paymentterm + " " + quote.PaymenttermDesc}</p>
          </>
        )) || (
          <SAPpaymenttermPicker
            title={"Payment conditions (" + ssp.DefaultPaymentterm + ")"}
            value={{
              value: quote.Paymentterm,
              label: quote.Paymentterm + " " + quote.PaymenttermDesc,
            }}
            updatefunc={(val) => {
              quote.change(val.value, "Paymentterm");
              quote.change(val.Name, "PaymenttermDesc");
            }}
          />
        )}
      </Grid>
      <Grid item xs={12}></Grid>
      {/* <Grid item xs={12} md={2}>
        <MyDatePicker
          title="Req. del date"
          value={quote.ReqDel}
          updatefunc={(val) => {
            quote.change(val, "ReqDel");
          }}
          viewonly={type === "extend"}
          format="DD-MM-YYYY"
          start={new Date()}
        />
      </Grid> */}

      <Grid
        item
        xs={12}
        md={3}
        className={
          quote.Shipmentterm !== ssp.DefaultShipmentterm ? classes.diff : ""
        }
      >
        {((type === "extend" || type === "replace") && (
          <>
            <label>Shipping conditions ({ssp.DefaultShipmentterm})</label>
            <p>{quote.Shipmentterm + " " + quote.ShipmenttermDesc}</p>
          </>
        )) || (
          <SAPShippingPicker
            title={"Shipping conditions (" + ssp.DefaultShipmentterm + ")"}
            value={{
              value: quote.Shipmentterm,
              label: quote.Shipmentterm + " " + quote.ShipmenttermDesc,
            }}
            updatefunc={(val) => {
              quote.change(val.value, "Shipmentterm");
              quote.change(val.Name, "ShipmenttermDesc");
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={quote.Incoterm1 !== ssp.DefaultIncoterm1 ? classes.diff : ""}
      >
        {((type === "extend" || type === "replace") && (
          <>
            <label>Incoterms ({ssp.DefaultIncoterm1})</label>
            <p>{quote.Incoterm1 + " " + quote.IncotermDesc}</p>
          </>
        )) || (
          <SAPIncotermPicker
            title={"Incoterms (" + ssp.DefaultIncoterm1 + ")"}
            value={{
              value: quote.Incoterm1,
              label: quote.Incoterm1 + " " + quote.IncotermDesc,
            }}
            updatefunc={(val) => {
              quote.change(val.value, "Incoterm1");
              quote.change(val.Name, "IncotermDesc");
            }}
          />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
        className={quote.Incoterm2 !== ssp.DefaultIncoterm2 ? classes.diff : ""}
      >
        {((type === "extend" || type === "replace") && (
          <>
            <label>. ({ssp.DefaultIncoterm2})</label>
            <p>{quote.Incoterm2}</p>
          </>
        )) ||
          (quote.Incoterm1 === "CIF" ||
          quote.Incoterm1 === "CFR" ||
          quote.Incoterm1 === "FOB" ? (
            <SAPInco2Picker
              title={". (" + ssp.DefaultIncoterm2 + ")"}
              value={{ label: quote.Incoterm2 }}
              updatefunc={(val) => {
                console.log(val);
                quote.change(val.label.substr(0, 28), "Incoterm2");
              }}
            />
          ) : (
            <ShortTextEditor
              title={". (" + ssp.DefaultIncoterm2 + ")"}
              value={quote.Incoterm2}
              updatefunc={(val) => {
                console.log(val.substr(0, 28));
                quote.change(val.substr(0, 28), "Incoterm2");
              }}
            />
          ))}
      </Grid>
      <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
        <label>
          Remarks on quote (this text will appear on the Quotation send to the
          customer)
        </label>
        <TextareaAutosize
          title="Remarks on quote (this text will appear on the Quotation send to the customer)"
          value={quote.Externaltext}
          onChange={(e) => {
            console.log(e.target.value);
            quote.change(e.target.value, "Externaltext");
          }}
          minRows={8}
          cols={80}
        />
      </Grid>
      <Grid item xs={12} style={{ display: "flex", flexDirection: "column" }}>
        <label>Remarks for internal sales (internal communication only)</label>
        <textarea
          onChange={(e) => {
            quote.change(e.target.value, "Internaltext");
          }}
          cols="80"
          rows="8"
          value={quote.Internaltext}
        ></textarea>
      </Grid>
    </Grid>
  );
});

const QuoteItems = observer(({ trySave, quote, type }) => {
  const classes = useStyles();
  const { instance, accounts } = useMsal();
  const lstore = useLocalStore(() => ({
    newItem: {
      Materialnr: "",
      Materialtext: "",
      CustomerMatID: "",
      CustomerMatText: "",
      Packagingcode: "",
      Packaging: "",
      Quantity: "0",
      Price: "0",
      PricePerTon: "0",
    },
    newItems: [],
    name: "",
    dir: 0,
  }));
  const canAdd = () =>
    lstore.newItem.Materialnr !== "" &&
    lstore.newItem.Packagingcode !== "" &&
    lstore.newItem.PricePerTon !== "0" &&
    lstore.newItem.Quantity !== "0";
  const importFile = (e) => {
    const enm = {
      MATERIAL: "Materialnr",
      PACKAGING: "Packagingcode",
      MINORDER: "Quantity",
      PRICE: "PricePerTon",
    };
    e.target.files[0].text().then((file) => {
      var firstLine = [];
      file.split("\r\n").forEach((line, li) => {
        console.log(line);
        if (li === 0) {
          firstLine = line.split(";");
        }
        if (li !== 0) {
          if (line.trim() !== "") {
            var newEl = {
              Materialnr: "",
              Materialtext: "",
              Packagingcode: "",
              Packaging: "",
              Quantity: "0",
              Price: "",
              PricePerTon: "0",
            };
            line.split(";").forEach((word, wi) => {
              newEl[enm[firstLine[wi].toUpperCase()]] = word.trim();
            });
            let matOptions = {
              method: "POST",
              credentials: "same-origin",
              body: JSON.stringify({
                proj: "Z_GW_PROSPECT_SRV",
                funct: "MaterialSet",
                parameters: `$top=20&$filter=MaterialID eq '${newEl.Materialnr}'&$format=json`,
              }),
            };
            let pacOptions = {
              method: "POST",
              credentials: "same-origin",
              body: JSON.stringify({
                proj: "Z_GW_PROSPECT_SRV",
                funct: "PackagingSet",
                parameters: `$top=20&$filter=PackagingID eq '${newEl.Packagingcode}'&$format=json`,
              }),
            };
            var sys = window.localStorage.getItem("QUOTEsys");
            let url = `SAPOData${sys}`;

            Promise.all([
              apiCall(url, matOptions, null, instance, accounts),
              apiCall(url, pacOptions, null, instance, accounts),
            ]).then(([mat, pac]) => {
              newEl.Packaging =
                pac.length > 0 ? pac[0].PackagingDescription : "null";
              newEl.Materialtext =
                mat.length > 0 ? mat[0].MaterialDescription : "null";
              lstore.newItems.push(newEl);
            });
          }
        }
      });
    });
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <Table size={"small"} padding="checkbox">
          <TableHead>
            <TableRow className={classes.row}>
              <TableCell></TableCell>
              <TableCell
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  lstore.name = "Materialtext";
                  if (lstore.dir === 0) {
                    lstore.dir = 1;
                  } else {
                    lstore.dir = lstore.dir * -1;
                  }
                  quote.sortItems(lstore.name, lstore.dir);
                  console.log(lstore.name + lstore.dir);
                }}
              >
                MaterialName (nr){" "}
                {lstore.dir === 0 ? (
                  <ImportExport color="primary" />
                ) : lstore.dir < 0 ? (
                  <ArrowUpward color="secondary" />
                ) : (
                  <ArrowDownward color="secondary" />
                )}
              </TableCell>
              <TableCell></TableCell>
              <TableCell>Cust MaterialName (nr)</TableCell>
              <TableCell></TableCell>
              <TableCell>Packaging</TableCell>
              <TableCell></TableCell>
              <TableCell size="small">Min order Qty in KG</TableCell>
              <TableCell>
                Price/T in {quote.Currency + " "}
                {type !== "extend" && (
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      quote.Items.forEach((el) => {
                        el.change(el.Oldprice, "PricePerTon");
                      });
                    }}
                    variant="outlined"
                    color="secondary"
                  >
                    Copy ALL
                  </Button>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody key={lstore.name + lstore.dir}>
            {quote.Items.map((el, i) => (
              <TableRow
                key={i}
                style={
                  el.Materialtext === "null" || el.Packaging === "null"
                    ? {
                        borderColor: "red",
                        color: "red",
                        fontStyle: "italic",
                        background: "coral",
                      }
                    : el.MaterialBlocked !== ""
                    ? { background: "red" }
                    : null
                }
              >
                <TableCell>
                  {(el.MaterialBlocked !== "" ||
                    el.Itemnr === "" ||
                    type !== "extend") && (
                    <IconButton
                      onClick={() => {
                        quote.delItem(i);
                      }}
                      size="small"
                    >
                      <Delete />
                    </IconButton>
                  )}
                </TableCell>
                <TableCell colSpan={2}>
                  <SAPMaterialPicker
                    title="SAP material nr"
                    value={
                      el.Materialnr !== ""
                        ? {
                            value: el.Materialnr,
                            label: `${el.Materialtext} (${el.Materialnr})`,
                          }
                        : null
                    }
                    updatefunc={({ value, Name }) => {
                      el.change(value, "Materialnr");
                      el.change(Name, "Materialtext");
                      el.change("todo", "CustomerMatID");
                      el.change("todo", "CustomerMatText");
                    }}
                    viewonly={el.Materialtext !== "null"}
                    viewFrame={false}
                  />
                </TableCell>
                <TableCell colSpan={2}>
                  <SAPMaterialPicker
                    title="Customer material nr"
                    value={{
                      value: el.CustomerMatID,
                      label:
                        el.CustomerMatID !== ""
                          ? `${el.CustomerMatText} (${el.CustomerMatID})`
                          : "/",
                    }}
                    updatefunc={({ value, Name }) => {
                      el.change(value, "Materialnr");
                      el.change(Name, "Materialtext");
                      el.change("todo", "CustomerMatID");
                      el.change("todo", "CustomerMatText");
                    }}
                    viewonly
                    viewFrame={false}
                  />
                </TableCell>
                <TableCell colSpan={2}>
                  <SAPpackagingPicker
                    value={{
                      label: `${el.Packagingcode} (${el.Packaging})`,
                      value: el.Packagingcode,
                    }}
                    updatefunc={(val) => {
                      el.change(val.value, "Packagingcode");
                      el.change(val.Name, "Packaging");
                    }}
                    viewonly={type === "extend"}
                  />
                </TableCell>
                <TableCell
                  size="small"
                  className={
                    trySave && el.Quantity === "0" ? classes.notCompl : ""
                  }
                >
                  <NumberEditor
                    repattern={"^\\d*$"}
                    value={el.Quantity}
                    updatefunc={(val) => {
                      el.change(val, "Quantity");
                    }}
                    required
                    viewonly={type === "extend"}
                  />
                </TableCell>
                <TableCell
                  className={
                    trySave && el.PricePerTon === "0" ? classes.notCompl : ""
                  }
                >
                  <Box display="flex" alignItems="baseline">
                    <NumberEditor
                      repattern={"^\\d*$"}
                      value={el.PricePerTon}
                      updatefunc={(val) => {
                        el.change(val, "PricePerTon");
                      }}
                      viewonly={type === "extend"}
                      required
                    />
                    {type !== "extend" && type !== "new" && (
                      <Link
                        style={{
                          paddingLeft: 15,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          el.change(el.Oldprice, "PricePerTon");
                        }}
                      >
                        {el.Oldprice}
                      </Link>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={12}>
        {type !== "extend" && (
          <Box style={{ background: "yellow" }}>
            <Grid container>
              <p></p>
              <Grid item xs={12}>
                <SAPMaterialPicker
                  title="SAP material nr"
                  value={
                    lstore.newItem.Materialnr !== ""
                      ? {
                          value: lstore.newItem.Materialnr,
                          label: lstore.newItem.Materialnr,
                        }
                      : null
                  }
                  updatefunc={(val) => {
                    console.log(val);
                    lstore.newItem.Materialnr = val.Id;
                    lstore.newItem.Materialtext = val.Name;
                    lstore.newItem.CustomerMatID = val.cusId;
                    lstore.newItem.CustomerMatText = val.cusName;
                  }}
                  salesOrg={quote.Salesorg}
                  customer={quote.Soldtonr}
                />
              </Grid>
              <Grid item xs={12}>
                <SAPMaterialPicker
                  title="Cust Material Name"
                  value={
                    lstore.newItem.Materialnr !== ""
                      ? {
                          value: lstore.newItem.CustomerMatID,
                          label: lstore.newItem.CustomerMatText,
                        }
                      : null
                  }
                  updatefunc={(val) => {
                    console.log(val);
                    lstore.newItem.Materialnr = val.Id;
                    lstore.newItem.Materialtext = val.Name;
                    lstore.newItem.CustomerMatID = val.cusId;
                    lstore.newItem.CustomerMatText = val.cusName;
                  }}
                  customerId={true}
                  salesOrg={quote.Salesorg}
                  customer={quote.Soldtonr}
                />
              </Grid>
              <Grid item xs={12}>
                <SAPpackagingPicker
                  title="Packaging"
                  value={
                    lstore.newItem.Packagingcode !== ""
                      ? {
                          value: lstore.newItem.Packagingcode,
                          label: `${lstore.newItem.Packagingcode} (${lstore.newItem.Packaging})`,
                        }
                      : null
                  }
                  updatefunc={({ Id, Name }) => {
                    lstore.newItem.Packagingcode = Id;
                    lstore.newItem.Packaging = Name;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NumberEditor
                  repattern={"^\\d*\\.?\\d*$"}
                  title="Min Order Qty/KG"
                  value={lstore.newItem.Quantity}
                  updatefunc={(val) => {
                    if (val !== "")
                      lstore.newItem.Quantity =
                        Number.parseFloat(val).toString();
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <NumberEditor
                  repattern={"^\\d*\\.?\\d*$"}
                  title="Price/ton"
                  value={lstore.newItem.PricePerTon}
                  updatefunc={(val) => {
                    if (val !== "")
                      lstore.newItem.PricePerTon =
                        Number.parseFloat(val).toString();
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    startIcon={<Add />}
                    onClick={() => {
                      quote.addItem(
                        { ...lstore.newItem },
                        lstore.name,
                        lstore.dir
                      );
                      lstore.newItem = {
                        Materialnr: "",
                        Materialtext: "",
                        Packagingcode: "",
                        Packaging: "",
                        Quantity: "0",
                        Price: "0",
                        PricePerTon: "0",
                      };
                    }}
                    style={{ cursor: "pointer" }}
                    disabled={!canAdd()}
                  >
                    Add Item
                  </Button>
                </Box>
                <Divider style={{ height: 1.5, backgroundColor: "black" }} />
              </Grid>
              {lstore.newItems.map((it, i) => (
                <Grid item xs={12} key={i}>
                  {`${it.Materialnr} ${it.Materialtext} ${it.Packagingcode} ${it.Packaging} ${it.Quantity} ${it.PricePerTon}`}
                  <Divider style={{ height: 1.5, backgroundColor: "black" }} />
                </Grid>
              ))}
            </Grid>
            {lstore.newItems.length === 0 && (
              <Button
                startIcon={<CloudUpload />}
                onClick={(e) => {
                  e.currentTarget.click();
                }}
                style={{ cursor: "pointer", backgroundColor: "#cccc" }}
                variant="outlined"
              >
                <input type="file" multiple={false} onChange={importFile} />
              </Button>
            )}
            {lstore.newItems.length > 0 && (
              <>
                <Button
                  startIcon={<Add />}
                  onClick={() => {
                    lstore.newItems.forEach((item) => {
                      quote.addItem(
                        {
                          ...item,
                          CustomerMatID: "",
                          CustomerMatText: "",
                        },
                        lstore.name,
                        lstore.dir
                      );
                    });
                    lstore.newItems = [];
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Add
                </Button>
                or
                <Button
                  startIcon={<MergeType />}
                  onClick={() => {
                    lstore.newItems.forEach((item) => {
                      const filtered = quote.Items.filter(
                        (el) =>
                          el.Materialnr === item.Materialnr &&
                          el.Packagingcode === item.Packagingcode &&
                          parseInt(el.Quantity).toString() === item.Quantity
                      ).pop();
                      console.log(filtered);
                      if (filtered) {
                        filtered.change(item.PricePerTon, "PricePerTon");
                      } else {
                        quote.addItem(
                          {
                            ...item,
                            CustomerMatID: "",
                            CustomerMatText: "",
                          },
                          lstore.name,
                          lstore.dir
                        );
                      }
                    });
                    lstore.newItems = [];
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Merge
                </Button>
              </>
            )}
          </Box>
        )}
      </Grid>
    </Grid>
  );
});
